import { 
  platformModuleslistApi,
  fetchYAxisFieldApi,
  fetchXAxisFieldApi
} from '@/api/graph'

export const dashboardChartsMixins = {
  created () {
    this.customer_id = localStorage.getItem('customer_id')
    this.getPlatformModuleList()
  },
  data () {
    return {
      customer_id: null,
      platformModules: [],
      xAxisList: [],
      yAxisList: []
    }
  },
  methods: {
    async getPlatformModuleList () {
      try {
        const { data } = await platformModuleslistApi()
        this.platformModules = data.data.modules_list
      } catch (e) {
        //console.log(e)
      }
    },
    async getXAxisList () {
      this.graphCreationPayload.x_axis = null
      this.graphCreationPayload.y_axis = null

      try {
        const { data } = await fetchXAxisFieldApi(this.graphCreationPayload.module_id)
        this.xAxisList = data.data.x_axis
      } catch (e) {
        //console.log(e)
      }
    },
    async getYAxisList () {
      this.graphCreationPayload.y_axis = null

      try {
        const { data } = await fetchYAxisFieldApi(this.graphCreationPayload.module_id, this.graphCreationPayload.x_axis)
        this.yAxisList = data.data.y_axis
      } catch (e) {
        //console.log(e)
      }
    }
  }
}